import React from 'react';
import { AuthData, AuthDataContext, DEFAULT_AUTH_DATA } from './context';
import { useLocation } from 'react-router';
import { SSO_INDEX } from '../../../constants/routes';

const AuthDataProvider: React.FC<React.PropsWithChildren<Record<never, any>>> = ({ children }) => {
  const location = useLocation();
  const [authData, setAuthData] = React.useState<AuthData>(DEFAULT_AUTH_DATA);

  React.useEffect(() => {
    if (location?.pathname !== SSO_INDEX) {
      setAuthData((current) => ({
        ...current,
        loginError: null,
        password: null,
        totp: null,
        totpSecret: null,
        username: null,
        regKey: null,
      }));
    }
  }, [location]);

  return <AuthDataContext.Provider value={{ authData, setAuthData }}>{children}</AuthDataContext.Provider>;
};

export default AuthDataProvider;
